var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box", staticStyle: { display: "flex" } },
    [
      _vm.dataSource.woa
        ? _c(
            "el-card",
            { staticClass: "box-card", attrs: { shadow: "hover" } },
            [
              _c("div", { staticClass: "content" }, [
                _c(
                  "a",
                  {
                    staticClass: "result",
                    attrs: {
                      target: "_blank",
                      href: "/resource/woa?_mode=es&q=" + this.keyword
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          "https://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/material/icon/v4/woa.png"
                      }
                    }),
                    _vm._v("找到相关媒体"),
                    _c("span", { staticClass: "number" }, [
                      _vm._v(_vm._s(_vm.dataSource.woa))
                    ]),
                    _vm._v("条")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      type: "text link",
                      target: "_blank",
                      href: "/resource/woa?_mode=es&q=" + this.keyword
                    }
                  },
                  [_c("i", { staticClass: "iconfont icon-right" })]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dataSource.weibo
        ? _c(
            "el-card",
            { staticClass: "box-card", attrs: { shadow: "hover" } },
            [
              _c("div", { staticClass: "content" }, [
                _c(
                  "a",
                  {
                    staticClass: "result",
                    attrs: {
                      target: "_blank",
                      href: "/resource/weibo?_mode=es&q=" + this.keyword
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          "https://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/material/icon/v4/weibo.png"
                      }
                    }),
                    _vm._v("找到相关媒体"),
                    _c("span", { staticClass: "number" }, [
                      _vm._v(_vm._s(_vm.dataSource.weibo))
                    ]),
                    _vm._v("条")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      type: "text link",
                      target: "_blank",
                      href: "/resource/weibo?_mode=es&q=" + this.keyword
                    }
                  },
                  [_c("i", { staticClass: "iconfont icon-right" })]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dataSource.xhs
        ? _c(
            "el-card",
            { staticClass: "box-card", attrs: { shadow: "hover" } },
            [
              _c("div", { staticClass: "content" }, [
                _c(
                  "a",
                  {
                    staticClass: "result",
                    attrs: {
                      target: "_blank",
                      href: "/resource/xhs?_mode=es&q=" + this.keyword
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          "https://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/material/icon/v4/xhs.png"
                      }
                    }),
                    _vm._v("找到相关媒体"),
                    _c("span", { staticClass: "number" }, [
                      _vm._v(_vm._s(_vm.dataSource.xhs))
                    ]),
                    _vm._v("条")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      type: "text link",
                      target: "_blank",
                      href: "/resource/xhs?_mode=es&q=" + this.keyword
                    }
                  },
                  [_c("i", { staticClass: "iconfont icon-right" })]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dataSource.live
        ? _c(
            "el-card",
            { staticClass: "box-card", attrs: { shadow: "hover" } },
            [
              _c("div", { staticClass: "content" }, [
                _c(
                  "a",
                  {
                    staticClass: "result",
                    attrs: {
                      target: "_blank",
                      href: "/resource/live?_mode=es&q=" + this.keyword
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          "https://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/material/icon/v4/live.png"
                      }
                    }),
                    _vm._v("找到相关媒体"),
                    _c("span", { staticClass: "number" }, [
                      _vm._v(_vm._s(_vm.dataSource.live))
                    ]),
                    _vm._v("条")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      type: "text link",
                      target: "_blank",
                      href: "/resource/live?_mode=es&q=" + this.keyword
                    }
                  },
                  [_c("i", { staticClass: "iconfont icon-right" })]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dataSource.video
        ? _c(
            "el-card",
            { staticClass: "box-card", attrs: { shadow: "hover" } },
            [
              _c("div", { staticClass: "content" }, [
                _c(
                  "a",
                  {
                    staticClass: "result",
                    attrs: {
                      target: "_blank",
                      href: "/resource/video?_mode=es&q=" + this.keyword
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          "https://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/material/icon/v4/video.png"
                      }
                    }),
                    _vm._v("找到相关媒体"),
                    _c("span", { staticClass: "number" }, [
                      _vm._v(_vm._s(_vm.dataSource.video))
                    ]),
                    _vm._v("条")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      type: "text link",
                      target: "_blank",
                      href: "/resource/video?_mode=es&q=" + this.keyword
                    }
                  },
                  [_c("i", { staticClass: "iconfont icon-right" })]
                )
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e827d46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e827d46","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_widget/ResultCount.vue
// module id = null
// module chunks = 